import cn from 'classnames';

import './Button.css';

const Button = (props) => {
  const { type='button', onClick, className, children, disabled } = props;

  const buttonClasses = cn('rntr-button', className, {
    'rntr-button_disabled': disabled
  });

  return (
    <button type={type} onClick={onClick} className={buttonClasses}>
      {children}
    </button>
  )
}

export default Button;